/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import { useGramContext } from "./_context.js";
import { QueryHookOptions, SuspenseQueryHookOptions } from "./_types.js";
import {
  buildGetUsageTiersQuery,
  GetUsageTiersQueryData,
  prefetchGetUsageTiers,
  queryKeyGetUsageTiers,
} from "./getUsageTiers.core.js";
export {
  buildGetUsageTiersQuery,
  type GetUsageTiersQueryData,
  prefetchGetUsageTiers,
  queryKeyGetUsageTiers,
};

export type GetUsageTiersQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getUsageTiers usage
 *
 * @remarks
 * Get the usage tiers
 */
export function useGetUsageTiers(
  options?: QueryHookOptions<GetUsageTiersQueryData, GetUsageTiersQueryError>,
): UseQueryResult<GetUsageTiersQueryData, GetUsageTiersQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildGetUsageTiersQuery(
      client,
      options,
    ),
    ...options,
  });
}

/**
 * getUsageTiers usage
 *
 * @remarks
 * Get the usage tiers
 */
export function useGetUsageTiersSuspense(
  options?: SuspenseQueryHookOptions<
    GetUsageTiersQueryData,
    GetUsageTiersQueryError
  >,
): UseSuspenseQueryResult<GetUsageTiersQueryData, GetUsageTiersQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildGetUsageTiersQuery(
      client,
      options,
    ),
    ...options,
  });
}

export function setGetUsageTiersData(
  client: QueryClient,
  data: GetUsageTiersQueryData,
): GetUsageTiersQueryData | undefined {
  const key = queryKeyGetUsageTiers();

  return client.setQueryData<GetUsageTiersQueryData>(key, data);
}

export function invalidateAllGetUsageTiers(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "usage", "getUsageTiers"],
  });
}
